<template>
  <modal-template size="small"
                  @close="$emit('closeAdviseSeats')">
    <b-row>
      <b-col cols="12">
        <figure class="picture">
          <picture>
            <b-img-lazy :src="require('@/assets/images/ic-info.png')"
                    alt="Modal error"
                    fluid />
          </picture>
        </figure>
      </b-col>
      <b-col cols="12"
             class="mB15">
        <p class="mT15">{{ $t('advise.minimoEntradas')}}</p>
        <ul>
          <li v-for="ticket in ticketsTypes" :key="ticket.title">
           - {{ $t('advise.entradasTipo', { title: ticket.title, min: ticket.min_tickets }) }}
           {{ $t('advise.entradasDisponible', { available: ticket.available }) }}
           {{ ticket.pair ? $t('advise.entradasPair') : '' }}
          </li>
        </ul>
        <br>
        <button class="btn transparent"
                @click="$emit('closeAdviseSeats')">{{ $t('modalReport.continuar') }}</button>
      </b-col>
    </b-row>
  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'

export default {
  components: {
    ModalTemplate
  },
  props: {
    ticketsTypes: {
      type: Array,
      default: () => []
    }
  },
}
</script>
